export default {
  alt: '언어 선택',
  en: {
    alt: '영어',
    title: '영어',
  },
  es: {
    alt: '스페인어',
    title: '스페인어',
  },
  close: {
    alt: '닫기',
  },
  ko: {
    alt: '한국어',
    title: '한국어',
  },
  zh: {
    alt: '중국어',
    title: '중국어',
  },
  vi: {
    alt: '베트남어',
    title: '베트남어',
  },
  ru: {
    alt: '러시아어',
    title: '러시아어',
  },
  'pt-PT': {
    alt: 'Portuguese (Portugal)',
    title: 'Portuguese (Portugal)',
  },
  'pt-BR': {
    alt: 'Portuguese (Brazil)',
    title: 'Portuguese (Brazil)',
  },
}
